const counterContainer = document.querySelectorAll('.callout-background-image-props');

//Detect if component is in view

var counterInView = new IntersectionObserver(function(entries, counterInView) {
    
    entries.forEach(function(entry) {
            if(entry.intersectionRatio > 0) {
                if (counterContainer.length > 0) {
                    //Get the value container    
                    const counterValue = document.querySelectorAll('.callout-background-image-props__prop-value');
                    //For each container
                    counterValue.forEach(function(value) {
                        //Get the actual data value in the attriute
                        const valueCount = value.getAttribute('data-count');
                        function animateValue(start, duration) {
                                //create the range of numbers
                                let range = 0 + valueCount;
                                let current = start;
                                let increment = 1;
                                //If the data value is bigger than 1000, 3000, increment by larger number
                                if(valueCount > 3000) {
                                    increment = 10;
                                } else if (valueCount > 1000) {
                                    increment = 5;
                                } else {
                                    increment = 1;
                                }
                                //Add the timer
                                var stepTime = Math.abs(Math.floor(duration / range));
                                var timer = setInterval(function() {
                                    current += increment;
                                    const valueText = value.querySelector('.value-text');
                                    //Make the text show as the current number
                                    valueText.innerHTML = current;
                                    //If current value is bigger or equal to the actual data value, set the text to the data value, otherwise number will keep climbing
                                    if (current >= valueCount) {
                                        valueText.innerHTML = valueCount;
                                        clearInterval(timer);
                                    }
                                }, stepTime);
                            
                        }
                        //Pass in the start value, and the duration
                        animateValue(0, 2000);
                    });
                }
                //Stop the component from being observed so the values only run on initial view
                counterInView.unobserve(entry.target);
            }
           
    });
    
});

//Pass the component container into Intersection Observer so it knows what to look for in view
counterContainer.forEach(function(view) {
        counterInView.observe(view);
});
